import { EntityName } from '@adm/backend-entity';

import { Models, UserRole } from '../enums';
import {
  adminPermissions,
  deviceOperatorPermissions,
  deviceQualityOperatorPermissions,
  operatorPermissions,
  operatorWithoutPBAccessPermissions,
  readOperatorPermissions,
  ttmOperatorPermissions,
} from './role-permissions';

import { Actions } from './actions.config';

export const caslPermissions: Record<
  UserRole,
  { actions: Array<keyof typeof Actions>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: adminPermissions,
  [UserRole.Operator]: operatorPermissions,
  [UserRole.OperatorWithoutPBAccess]: operatorWithoutPBAccessPermissions,
  [UserRole.DeviceOperator]: deviceOperatorPermissions,
  [UserRole.OperatorReadAccess]: readOperatorPermissions,
  [UserRole.TtmOperator]: ttmOperatorPermissions,
  [UserRole.DeviceQualityOperator]: deviceQualityOperatorPermissions,
};
